import useSWR from "swr";
import { jsonFetch } from "lib/fetcher";

export function useDataSummary(opts) {
  return useSWR(`${process.env.REACT_APP_API_URL}/api/summary`, jsonFetch, opts);
}


export function useMapData(opts) {
  return useSWR(`${process.env.REACT_APP_API_URL}/api/map-data`, jsonFetch, opts);
}

export function useCountyName(country, state, county) {
  return useSWR(`${process.env.REACT_APP_API_URL}/api/map-data/county?country=${country}&state=${state}&county=${county}`, jsonFetch);
}

export function useAvailableCounties(country, state) {
  return useSWR(`${process.env.REACT_APP_API_URL}/api/map-data/counties?country=${country}&state=${state}`, jsonFetch);
}